const Authroutes = {
  path: '/auth',
  component: () => import('@/layouts/blank/BlankLayout.vue'),
  meta: {
    requireAuth: false
  },
  redirect: '/auth/login',
  children: [
    {
      name: 'login',
      path: '/auth/login',
      component: () => import('@/pages/auth/TheLogin.vue')
    },
    {
      name: 'callback',
      path: '/auth/callback/:token',
      component: () => import('@/pages/auth/TheCallback.vue')
    }
  ]
};

export default Authroutes;